import { CSSProperties, forwardRef, MouseEventHandler, PropsWithChildren } from 'react';
import cn from 'classnames';
import { WorkdayIcon } from '@icons';
import { shiftButtonHoverClassname } from '@lp/features/Scheduler/constants';
import { ShiftSiblingData } from '@lp/features/Scheduler/types';

type ShiftButtonProps = PropsWithChildren<{
  lighten?: boolean;
  disabled?: boolean;
  isCentered?: boolean;
  siblingData?: ShiftSiblingData;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  showHrIcon?: boolean;
  style?: CSSProperties;
}>;

export const ShiftButton = forwardRef<HTMLButtonElement, ShiftButtonProps>(
  ({ lighten, disabled, isCentered, className, siblingData, children, onClick, showHrIcon, style }, ref) => {
    const { hasPrev, hasNext, hasPartialPrev, hasPartialNext } = siblingData ?? {};

    return (
      <button
        ref={ref}
        onClick={onClick}
        disabled={disabled}
        style={style}
        className={cn(
          'flex relative size-full px-2 py-1 text-s-m rounded-lg overflow-hidden',
          {
            [shiftButtonHoverClassname]: !disabled,
            'border-s-0 -ml-px w-[calc(100%+1px)]': hasPrev,
            'border-e-0': hasNext,
            'rounded-s-none': hasPrev || hasPartialPrev,
            'rounded-e-none': hasNext || hasPartialNext,
            'flex items-center': isCentered,
            'opacity-60': lighten,
          },
          className,
        )}
      >
        {children}
        {showHrIcon && (
          <WorkdayIcon className="absolute bottom-1 right-[3.5px] shrink-0 opacity-50 z-2" width={12} height={12} />
        )}
      </button>
    );
  },
);
